export default __webpack_public_path__ + "static/media/gi.f581957e.svg";